import { useState, useEffect } from 'react'
import axios, { AxiosResponse, AxiosError } from 'axios'

import Slick from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import Slide from './card'

import PrevButton from '../../../../../src/components/slider/PrevButton'
import NextButton from '../../../../../src/components/slider/NextButton'

type Slider = {
  title: string
  image: string
  uri: string
}
function HomeSlider() {
  const [homeSliders, setHomeSliders] = useState<Slider[]>()

  useEffect(() => {
    fetchHomeSlider()
  }, [])

  const fetchHomeSlider = () => {
    axios({
      method: 'GET',
      url: `${import.meta.env.VITE_API_BASE_URI}/api/v1/home/sliders`,
    })
      .then((response: AxiosResponse<{ sliders: Slider[] }>) => {
        setHomeSliders(response.data.sliders)
      })
      .catch((error: AxiosError<{ error: string }>) => {
        console.error('error', error)
      })
  }

  const settings = {
    autoplay: true,
    autoplaySpeed: 5000,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: <PrevButton />,
    nextArrow: <NextButton />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  return homeSliders && homeSliders.length > 0 ? (
    <section className="section news-section">
      <div className="ttl-flex">
        <h2 className="section-ttl">お知らせ</h2>
      </div>
      <Slick {...settings}>
        {homeSliders.map((homeSlider, index) => (
          <Slide
            key={index}
            title={homeSlider.title}
            image={homeSlider.image}
            uri={homeSlider.uri}
          />
        ))}
      </Slick>
    </section>
  ) : (
    <></>
  )
}

export default HomeSlider
